import { createContext, useState, PropsWithChildren, useContext, useEffect } from 'react';
import { getPlatformApi } from '../utils/detect-platform';
import { PlatformApi } from '../types/platform-api';
import { PlatformConfig } from '../types/platform-config';

type PlatformState = {
  platform: PlatformApi;
};

export const PlatformContext = createContext<PlatformState | null>(null);

export const PlatformProvider = ({
  children,
  platformConfig,
}: PropsWithChildren & { platformConfig: PlatformConfig }): React.JSX.Element => {
  console.log('PlatformProvider', platformConfig);
  const [state] = useState<PlatformState>({
    platform: getPlatformApi(platformConfig),
  });

  return <PlatformContext.Provider value={state}>{children}</PlatformContext.Provider>;
};

export const usePlatform = () => {
  const context = useContext(PlatformContext);
  if (context === null) {
    throw new Error('usePlatform must be used within a PlatformProvider');
  }
  return context;
};

/** True on a mobile Discord client (via the Discord SDK's platform). Web is false. */
export const useIsMobile = (): boolean => usePlatform().platform.isMobile;
